import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[hoverImageSwap=*]'
})
export class HoverImageSwapDirective {
  @Input() hoverImageSwap!: string;
  @Input() set src(src: string) {
    this.srcValue = src;
    this.setSrc(src);
  }

  private srcValue: string | undefined;
  private restoreTimeout: any;

  @HostListener('touchstart')
  @HostListener('mouseenter') onMouseEnter() {
    this.swap();
    if (this.restoreTimeout) {
      clearTimeout(this.restoreTimeout);
      this.restoreTimeout = undefined;
    }
  }

  @HostListener('touchend')
  onTouchEnd() {
    this.restoreTimeout = setTimeout(() => {
      this.restore();
      this.restoreTimeout = undefined;
    }, 5000);
  }

  @HostListener('mouseleave') onMouseLeave() {
    this.restore();
  }

  constructor(private el: ElementRef) {}

  private swap() {
    if (this.srcValue) {
      this.setSrc(this.hoverImageSwap);
    }
  }

  private restore() {
    if (this.srcValue) {
      this.setSrc(this.srcValue);
    }
  }
  private setSrc(src: string) {
    this.el.nativeElement.setAttribute('src', src);
  }
}
